import { css, CSSResult } from 'lit'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorAction, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cseHotspotTarget = {
  backgroundColor: css`var(--cse-hotspot-target-background-color, ${csColorAction.hotspot})`,
  backgroundColorHover: css`var(--cse-hotspot-target-background-color-hover, ${csColorAction.hotspotHover})`,
  borderRadius: css`var(--cse-hotspot-target-border-radius, ${csBorder.radiusFull})`,
  color: css`var(--cse-hotspot-target-color, ${csColorText.body})`,
  colorHover: css`var(--cse-hotspot-target-color-hover, ${csColorAction.primary})`,
  outlineBackgroundColor: css`var(--cse-hotspot-target-outline-background-color, ${csColorAction.hotspot})`,
  outlineBackgroundColorHover: css`var(--cse-hotspot-target-outline-background-color-hover, ${csColorAction.hotspotHover})`,
  sizeDesktop: css`var(--cse-hotspot-target-size-desktop, 40px)`,
  sizeMobile: css`var(--cse-hotspot-target-size-mobile, 35px)`,
}

export const style: CSSResult = css`
  .cse-hotspot-target {
    color: ${cseHotspotTarget.color};
    display: grid;
    background-color: ${cseHotspotTarget.backgroundColor};
    border-radius: ${cseHotspotTarget.borderRadius};
    border-width: 0;
    font-size: inherit;
    place-items: center;
    place-content: center;
    position: relative;
    transition-duration: ${csTransition.duration};
    transition-property: color;
    transition-timing-function: ${csTransition.timingFunction};
  }

  .size-small,
  .size-small::before,
  .size-small::after {
    height: ${cseHotspotTarget.sizeMobile};
    width: ${cseHotspotTarget.sizeMobile};
  }

  .size-large,
  .size-large::before,
  .size-large::after {
    height: ${cseHotspotTarget.sizeDesktop};
    width: ${cseHotspotTarget.sizeDesktop};
  }

  .cse-hotspot-target:hover {
    color: ${cseHotspotTarget.colorHover};
    background-color: ${cseHotspotTarget.backgroundColorHover};
    cursor: pointer;
  }

  .cse-hotspot-target::before {
    animation: pulsate 2s infinite;
    content: '';
    background-color: ${csColorAction.hotspot};
    border-radius: ${cseHotspotTarget.borderRadius};
    opacity: 0;
    position: absolute;
    transform: scale(1);
    transition: transform .3s ease-in-out;
    z-index: -2;
  }

  .cse-hotspot-target:hover::before {
    animation-play-state: paused;
  }

  @keyframes pulsate {
    0% {
      transform: scale(1);
      opacity: .66;
    }

    70%  {
      transform: scale(1.5);
      opacity: 0;
    }

    100% {
      transform: scale(1.0);
    }
  }

  .cse-hotspot-target::after {
    background-color: ${cseHotspotTarget.outlineBackgroundColor};
    border-radius: ${cseHotspotTarget.borderRadius};
    box-shadow: 0 0 0 5px rgba(255 255 255 / 0%);
    content: '';
    position: absolute;
    transform: scale(1);
    transition-duration: .3s;
    transition-property: transform box-shadow;
    transition-timing-function: ease-in-out;
    z-index: -1;
  }

  .cse-hotspot-target:hover::after {
    box-shadow: 0 0 0 5px ${csColorAction.hotspot};
    transform: scale(1.25);
    background-color: ${cseHotspotTarget.outlineBackgroundColorHover};
  }
`
